'use client';
import React, { useEffect, useState } from 'react';
import { useAuthenticated } from '@/hooks/useAuthenticated';
import { getSimilarTenders } from '@/api/requests/tenders';
import { Tender } from '@/actions/dtos/tender/tender';
import CarouselWrapper from '@/components/common/CarouselWrapper';
import TenderPreviewCard from '@/components/tender/TenderPreviewCard';

interface SimilarTendersSectionProps {
  tenderId: string;
}

const SimilarTendersSection: React.FC<SimilarTendersSectionProps> = ({ tenderId }) => {
  const { isAuthenticated, isLoading: isAuthenticatedLoading } = useAuthenticated();
  const [similarTenders, setSimilarTenders] = useState<Tender[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSimilarTendersData = async () => {
      const similarTendersData = await getSimilarTenders(tenderId, !isAuthenticated);

      const similarTendersArray = similarTendersData.map((st: { tender: Tender; score: number }) => ({
        ...st.tender,
        score: st.score,
      }));

      setSimilarTenders(similarTendersArray);
      setIsLoading(false);
    };

    if (!isAuthenticatedLoading) {
      fetchSimilarTendersData();
    }
  }, [isAuthenticated, isAuthenticatedLoading, tenderId]);

  if (isLoading) {
    return (
      <div className="mt-6 flex w-full items-center">
        <span className="loading loading-spinner mx-auto flex items-center" />
      </div>
    );
  }

  if (similarTenders.length === 0) {
    return null;
  }

  return (
    <div className="mx-auto mt-10 flex max-w-7xl flex-col items-center text-center">
      <h2 className="text-2xl font-normal">Ähnliche Ausschreibungen</h2>
      <CarouselWrapper
        items={similarTenders}
        autoRotate={false}
        renderCard={(tender: Tender, index: number) => (
          <TenderPreviewCard tender={tender} key={index} showScore={true} />
        )}
      />
    </div>
  );
};

export default SimilarTendersSection;
